import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const EmailField: FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FormInput
        name={`emails.${index}.emailType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
      />
      <FormInput name={`emails.${index}.email`} placeholder="example@email.dev" />
    </FieldLayout>
  );
};
